import { Home, Users } from 'react-feather';
import DeliveryDining from '@mui/icons-material/DeliveryDining';
import MenuBook from '@mui/icons-material/MenuBook';
import Book from '@mui/icons-material/Book';
import School from '@mui/icons-material/School';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import FoodBank from '@mui/icons-material/FoodBank';
import Repeat from '@mui/icons-material/Repeat';
import Balance from '@mui/icons-material/Balance';
import Email from '@mui/icons-material/Email';
import Report from '@mui/icons-material/Report';

const dashboard = {
  title: 'Dashboard',
  icon: Home,
  type: 'link',
  active: false,
  path: '/dashboard',
};

export const ADMINMENUITEMS = [
  {
    title: 'Delivery Runs',
    icon: DeliveryDining,
    type: 'sub',
    active: false,
    children: [
      { path: '/delivery-runs/manage', title: 'Manage', type: 'link' },
      { path: '/delivery-runs/create', title: 'Create', type: 'link' },
    ],
  },
  {
    title: 'Exceptions',
    icon: Book,
    type: 'sub',
    active: false,
    children: [
      { path: '/exceptions/manage', title: 'Manage', type: 'link' },
      { path: '/exceptions/create', title: 'Create', type: 'link' },
    ],
  },
  {
    title: 'Reports',
    icon: Report,
    type: 'sub',
    active: false,
    children: [
      {
        path: '/reports/delivery-run-summary',
        title: 'School Summary',
        type: 'link',
      },
      {
        path: '/reports/stock-summary',
        title: 'Stock Summary',
        type: 'link',
      },
      // { path: "/reports/delivery-run-details", title: "Details", type: "link" },
    ],
  },
  { type: 'divider' },
  { title: 'Admin', type: 'heading' },
  {
    title: 'Emails',
    icon: Email,
    path: '/emails/manage',
    type: 'link',
    active: false,
  },
  {
    title: 'Delivery Run Types',
    icon: DeliveryDining,
    type: 'link',
    path: '/delivery-run-types/manage',
    active: false,
  },
  {
    title: 'Public Holidays',
    icon: CalendarMonth,
    type: 'link',
    path: '/public-holidays/manage',
    active: false,
  },
  {
    title: 'Menus',
    icon: MenuBook,
    type: 'sub',
    active: false,
    children: [
      { path: '/menus/manage', title: 'Menus', type: 'link' },
      { path: '/menu-details/manage', title: 'Menu Details', type: 'link' },
    ],
  },
  {
    title: 'Projects',
    icon: Book,
    type: 'link',
    path: '/projects/manage',
    active: false,
  },
  {
    title: 'Field Workers',
    icon: Users,
    type: 'link',
    path: '/field-workers/manage',
    active: false,
  },
  {
    title: 'School Calendars',
    icon: CalendarMonth,
    type: 'sub',
    active: false,
    children: [
      { path: '/school-calendars/manage', title: 'Calendars', type: 'link' },
      { path: '/school-calendar-terms/manage', title: 'Terms', type: 'link' },
    ],
  },
  {
    title: 'Schools',
    icon: School,
    type: 'link',
    path: '/schools/manage',
    active: false,
  },
  {
    title: 'SKU Types',
    icon: FoodBank,
    type: 'link',
    path: '/sku-types/manage',
    active: false,
  },
  {
    title: 'SKUS',
    icon: FoodBank,
    type: 'sub',
    active: false,
    children: [
      { path: '/skus/manage', title: 'Manage', type: 'link' },
      { path: '/skus/create', title: 'Create', type: 'link' },
    ],
  },
  {
    title: 'Unit Of Measures',
    icon: Balance,
    type: 'link',
    active: false,
    path: '/uom/manage',
  },
  {
    title: 'UOM Conversions',
    icon: Repeat,
    type: 'link',
    active: false,
    path: '/uom-conversions/manage',
  },
  {
    title: 'Action Logs',
    icon: Book,
    type: 'link',
    active: false,
    path: '/action-logs/manage',
  },

  // {
  //   title: "Emails",
  //   icon: Email,
  //   type: "sub",
  //   active: false,
  //   children: [
  //     { path: "/emails/manage", title: "Manage", type: "link" },
  //     { path: "/emails/view", title: "View", type: "link" },
  //   ],
  // },

  {
    title: 'Users',
    icon: Users,
    type: 'sub',
    active: false,
    children: [
      { path: '/users/manage', title: 'Manage', type: 'link' },
      { path: '/users/create', title: 'Create', type: 'link' },
    ],
  },
];

export const SUPERUSERMENUITEMS = [
  {
    title: 'Delivery Runs',
    icon: DeliveryDining,
    type: 'link',
    active: false,
    path: '/delivery-runs/manage',
  },
  {
    title: 'Delivery Run Types',
    icon: DeliveryDining,
    type: 'link',
    path: '/delivery-run-types/manage',
    active: false,
  },
  // {
  //   title: "Emails",
  //   icon: Email,
  //   type: "sub",
  //   active: false,
  //   children: [
  //     { path: "/emails/manage", title: "Manage", type: "link" },
  //     { path: "/delivery-runs/view", title: "View", type: "link" },
  //   ],
  // },
  {
    title: 'Exceptions',
    icon: Book,
    type: 'link',
    active: false,
    path: '/exceptions/manage',
  },
  {
    title: 'Field Workers',
    icon: Users,
    type: 'link',
    path: '/field-workers/manage',
    active: false,
  },
  {
    title: 'Menus',
    icon: MenuBook,
    type: 'link',
    active: false,
    path: '/menus/manage',
  },
  {
    title: 'Projects',
    icon: Book,
    type: 'link',
    path: '/projects/manage',
    active: false,
  },
  {
    title: 'Public Holidays',
    icon: CalendarMonth,
    type: 'link',
    path: '/public-holidays/manage',
    active: false,
  },
  {
    title: 'Reports',
    icon: Report,
    type: 'sub',
    active: false,
    children: [
      { path: '/reports/delivery-run-summary', title: 'Summaries', type: 'link' },
      { path: '/reports/delivery-run-details', title: 'Details', type: 'link' },
    ],
  },
  {
    title: 'Schools',
    icon: School,
    type: 'link',
    path: '/schools/manage',
    active: false,
  },
  {
    title: 'School Calendars',
    icon: CalendarMonth,
    type: 'sub',
    active: false,
    children: [
      { path: '/school-calendars/manage', title: 'Calendars', type: 'link' },
      { path: '/school-calendar-terms/manage', title: 'Terms', type: 'link' },
    ],
  },
  {
    title: 'SKUS',
    icon: FoodBank,
    type: 'link',
    path: '/skus/manage',
    active: false,
  },
  {
    title: 'SKU Types',
    icon: FoodBank,
    type: 'link',
    path: '/sku-types/manage',
    active: false,
  },
  {
    title: 'Unit Of Measures',
    icon: Balance,
    type: 'link',
    active: false,
    path: '/uom/manage',
  },
  {
    title: 'UOM Conversions',
    icon: Repeat,
    type: 'link',
    active: false,
    path: '/uom-conversions/manage',
  },
  {
    title: 'Users',
    icon: Users,
    type: 'sub',
    active: false,
    children: [
      { path: '/users/manage', title: 'Manage', type: 'link' },
      { path: '/users/create', title: 'Create', type: 'link' },
    ],
  },
];

export const APPLICATORMENUITEMS = [
  {
    title: 'Delivery Runs',
    icon: DeliveryDining,
    type: 'link',
    active: false,
    path: '/delivery-runs/manage',
  },
  {
    title: 'Delivery Run Types',
    icon: DeliveryDining,
    type: 'link',
    path: '/delivery-run-types/manage',
    active: false,
  },
  {
    title: 'Exceptions',
    icon: Book,
    type: 'sub',
    active: false,
    children: [
      { path: '/exceptions/manage', title: 'Manage', type: 'link' },
      { path: '/exceptions/create', title: 'Create', type: 'link' },
    ],
  },
  {
    title: 'Field Workers',
    icon: Users,
    type: 'link',
    path: '/field-workers/manage',
    active: false,
  },
  {
    title: 'Menus',
    icon: MenuBook,
    type: 'link',
    active: false,
    path: '/menus/manage',
  },
  {
    title: 'Projects',
    icon: Book,
    type: 'link',
    path: '/projects/manage',
    active: false,
  },
  {
    title: 'Public Holidays',
    icon: CalendarMonth,
    type: 'link',
    path: '/public-holidays/manage',
    active: false,
  },
  {
    title: 'Reports',
    icon: Report,
    type: 'sub',
    active: false,
    children: [
      { path: '/reports/delivery-run-summary', title: 'Summaries', type: 'link' },
      { path: '/reports/delivery-run-details', title: 'Details', type: 'link' },
    ],
  },
  {
    title: 'Schools',
    icon: School,
    type: 'link',
    path: '/schools/manage',
    active: false,
  },
  {
    title: 'School Calendars',
    icon: CalendarMonth,
    type: 'sub',
    active: false,
    children: [
      { path: '/school-calendars/manage', title: 'Calendars', type: 'link' },
      { path: '/school-calendar-terms/manage', title: 'Terms', type: 'link' },
    ],
  },
  {
    title: 'SKUS',
    icon: FoodBank,
    type: 'link',
    path: '/skus/manage',
    active: false,
  },
  {
    title: 'SKU Types',
    icon: FoodBank,
    type: 'link',
    path: '/sku-types/manage',
    active: false,
  },
  {
    title: 'Unit Of Measures',
    icon: Balance,
    type: 'link',
    active: false,
    path: '/uom/manage',
  },
  {
    title: 'UOM Conversions',
    icon: Repeat,
    type: 'link',
    active: false,
    path: '/uom-conversions/manage',
  },
];

export const VIEWERMENUITEMS = [
  {
    title: 'Delivery Runs',
    icon: DeliveryDining,
    type: 'link',
    active: false,
    path: '/delivery-runs/manage',
  },
  {
    title: 'Delivery Run Types',
    icon: DeliveryDining,
    type: 'link',
    path: '/delivery-run-types/manage',
    active: false,
  },
  {
    title: 'Exceptions',
    icon: Book,
    type: 'link',
    active: false,
    path: '/exceptions/manage',
  },
  {
    title: 'Field Workers',
    icon: Users,
    type: 'link',
    path: '/field-workers/manage',
    active: false,
  },
  {
    title: 'Menus',
    icon: MenuBook,
    type: 'link',
    active: false,
    path: '/menus/manage',
  },
  {
    title: 'Projects',
    icon: Book,
    type: 'link',
    path: '/projects/manage',
    active: false,
  },
  {
    title: 'Public Holidays',
    icon: CalendarMonth,
    type: 'link',
    path: '/public-holidays/manage',
    active: false,
  },
  {
    title: 'Reports',
    icon: Report,
    type: 'sub',
    active: false,
    children: [
      { path: '/reports/delivery-run-summary', title: 'Summaries', type: 'link' },
      { path: '/reports/delivery-run-details', title: 'Details', type: 'link' },
    ],
  },
  {
    title: 'Schools',
    icon: School,
    type: 'link',
    path: '/schools/manage',
    active: false,
  },
  {
    title: 'School Calendars',
    icon: CalendarMonth,
    type: 'sub',
    active: false,
    children: [
      { path: '/school-calendars/manage', title: 'Calendars', type: 'link' },
      { path: '/school-calendar-terms/manage', title: 'Terms', type: 'link' },
    ],
  },
  {
    title: 'SKUS',
    icon: FoodBank,
    type: 'link',
    path: '/skus/manage',
    active: false,
  },
  {
    title: 'SKU Types',
    icon: FoodBank,
    type: 'link',
    path: '/sku-types/manage',
    active: false,
  },
  {
    title: 'Unit Of Measures',
    icon: Balance,
    type: 'link',
    active: false,
    path: '/uom/manage',
  },
  {
    title: 'UOM Conversions',
    icon: Repeat,
    type: 'link',
    active: false,
    path: '/uom-conversions/manage',
  },
];

export const getMenuList = (role) => {
  let items = [];
  switch (role) {
    case 'ADMINISTRATOR':
      items = ADMINMENUITEMS;
      break;
    case 'APPLICATOR':
      items = APPLICATORMENUITEMS;
      break;
    case 'SUPERUSER':
      items = SUPERUSERMENUITEMS;
      break;
    case 'VIEWER':
      items = VIEWERMENUITEMS;
      break;
    default:
  }
  return items;
};
